<template>
    <div>
        <form id="documents" enctype="multipart/form-data">
            <div class="container p-3 pt-5 my-4 border in-border-header">
                <kt-form-section is_first>
                    <div class="section-header">
                        {{ $t('pos.documents') }}
                    </div>
                    <kt-row>
                        <kt-col v-if="form_data.customer_detail.customer_type_id==customerType.LEGAL" lg="4" md="4"
                                xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="statute_pages_img">
                                        {{ $t('pos.document.statute_pages') }}
                                    </kt-form-label>
                                    <kt-form-label for="statute_pages_img"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input v-if="can_change_documents"
                                           @change="processFile($event)"
                                           type="file"
                                           id="statute_pages_img"
                                           name="statute_pages_img"
                                           class="custom-file-upload"
                                           accept=".jpg,.jpeg,.pdf,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="images_url.statute_pages_img &&
                             wizard.document_operation == manageDocuments.UPLOAD"
                                 class="custom-control custom-checkbox special-tooltip"
                                 style="position:relative;right: 5%;top:0%;display: inline">
                                <input type="checkbox" class="custom-control-input"
                                       id="statute_pages_img_checkbox"
                                       name="statute_pages_img"
                                       v-model="checkboxes.statute_pages_img"
                                >
                                <span class="tooltip-text" style="right: -80%">{{ $t('pos.statuses.Switch') }}</span>
                                <label class="custom-control-label" id="statute_pages_img_checkbox_label"
                                       for="statute_pages_img_checkbox"></label>
                            </div>
                            <div v-show="images_url.statute_pages_img && show_delete_icon"
                                 style="position:relative;right: 80%;top:0%;display: inline"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('statute_pages_img')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <div v-show="images_url.statute_pages_img && $can('manage','pos')"
                                 style="position:relative;right: 6%;top:-1%;display: inline">
                                <span :class="document_classes.statute_pages_img"
                                      v-if="wizard.document_operation == manageDocuments.UPLOAD && form_data.documents.statute_pages_img.status"
                                      @click="show_rejection_reasons('statute_pages_img')"
                                >{{ form_data.documents.statute_pages_img.status_str }}</span>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="images_url.statute_pages_img">
                                <object v-if="image_type_view.statute_pages_img == documentFormat.PDF"
                                        style="position: relative;height: 300px!important;width: 100%"
                                        :data="images_url.statute_pages_img" type="application/pdf">
                                </object>
                                <kt-img-magnifier v-else class="mb-4"
                                                  :src="images_url.statute_pages_img"
                                ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col v-if="form_data.customer_detail.customer_type_id==customerType.LEGAL" lg="4" md="4"
                                xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="last_newspaper_img_introduce_sh">
                                        {{ $t('pos.document.last_newspaper_img_introduce_sh') }}
                                    </kt-form-label>
                                    <kt-form-label for="last_newspaper_img_introduce_sh"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input v-if="can_change_documents"
                                           @change="processFile($event)"
                                           type="file"
                                           id="last_newspaper_img_introduce_sh"
                                           name="last_newspaper_img_introduce_sh"
                                           class="custom-file-upload"
                                           accept=".jpg,.jpeg,.pdf,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="images_url.last_newspaper_img_introduce_sh &&
                             wizard.document_operation == manageDocuments.UPLOAD"
                                 class="custom-control custom-checkbox special-tooltip"
                                 style="position:relative;right: 5%;top:0%;display: inline">
                                <input type="checkbox" class="custom-control-input"
                                       id="last_newspaper_img_introduce_sh_checkbox"
                                       name="last_newspaper_img_introduce_sh"
                                       v-model="checkboxes.last_newspaper_img_introduce_sh"
                                >
                                <span class="tooltip-text" style="right: -80%">{{ $t('pos.statuses.Switch') }}</span>
                                <label class="custom-control-label" id="last_newspaper_img_introduce_sh_checkbox_label"
                                       for="last_newspaper_img_introduce_sh_checkbox"></label>
                            </div>
                            <div v-show="images_url.last_newspaper_img_introduce_sh && show_delete_icon"
                                 style="position:relative;right: 80%;top:0%;display: inline"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('last_newspaper_img_introduce_sh')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <div v-show="images_url.last_newspaper_img_introduce_sh && $can('manage','pos')"
                                 style="position:relative;right: 6%;top:-1%;display: inline">
                                <span :class="document_classes.last_newspaper_img_introduce_sh"
                                      v-if="wizard.document_operation == manageDocuments.UPLOAD && form_data.documents.last_newspaper_img_introduce_sh.status"
                                      @click="show_rejection_reasons('last_newspaper_img_introduce_sh')"
                                >{{ form_data.documents.last_newspaper_img_introduce_sh.status_str }}</span>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="images_url.last_newspaper_img_introduce_sh">
                                <object v-if="image_type_view.last_newspaper_img_introduce_sh == documentFormat.PDF"
                                        style="position: relative;height: 300px!important;width: 100%"
                                        :data="images_url.last_newspaper_img_introduce_sh" type="application/pdf">
                                </object>
                                <kt-img-magnifier v-else class="mb-4"
                                                  :src="images_url.last_newspaper_img_introduce_sh"
                                ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col v-if="form_data.customer_detail.customer_type_id==customerType.LEGAL" lg="4" md="4"
                                xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="birth_certificate_first_page_of_first_sh">
                                        {{ $t('pos.document.birth_certificate_first_page_of_first_sh') }}
                                    </kt-form-label>
                                    <kt-form-label for="birth_certificate_first_page_of_first_sh"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input v-if="can_change_documents"
                                           @change="processFile($event)"
                                           type="file"
                                           id="birth_certificate_first_page_of_first_sh"
                                           name="birth_certificate_first_page_of_first_sh"
                                           class="custom-file-upload"
                                           accept=".jpg,.jpeg,.pdf,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="images_url.birth_certificate_first_page_of_first_sh &&
                            wizard.document_operation == manageDocuments.UPLOAD"
                                 class="custom-control custom-checkbox special-tooltip"
                                 style="position:relative;right: 5%;top:0%;display: inline">
                                <input type="checkbox" class="custom-control-input"
                                       id="birth_certificate_first_page_of_first_sh_checkbox"
                                       name="birth_certificate_first_page_of_first_sh"
                                       v-model="checkboxes.birth_certificate_first_page_of_first_sh"
                                >
                                <span class="tooltip-text" style="right: -80%">{{ $t('pos.statuses.Switch') }}</span>
                                <label class="custom-control-label"
                                       id="birth_certificate_first_page_of_first_sh_checkbox_label"
                                       for="birth_certificate_first_page_of_first_sh_checkbox"></label>
                            </div>
                            <div v-show="images_url.birth_certificate_first_page_of_first_sh&& show_delete_icon"
                                 style="position:relative;right: 80%;top:0%;display: inline"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('birth_certificate_first_page_of_first_sh')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <div v-show="images_url.birth_certificate_first_page_of_first_sh && $can('manage','pos')"
                                 style="position:relative;right: 6%;top:-1%;display: inline">
                                <span :class="document_classes.birth_certificate_first_page_of_first_sh"
                                      v-if="wizard.document_operation == manageDocuments.UPLOAD && form_data.documents.birth_certificate_first_page_of_first_sh.status"
                                      @click="show_rejection_reasons('birth_certificate_first_page_of_first_sh')"
                                >{{ form_data.documents.birth_certificate_first_page_of_first_sh.status_str }}</span>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="images_url.birth_certificate_first_page_of_first_sh">
                                <object v-if="image_type_view.birth_certificate_first_page_of_first_sh == documentFormat.PDF"
                                        style="position: relative;height: 300px!important;width: 100%"
                                        :data="images_url.birth_certificate_first_page_of_first_sh"
                                        type="application/pdf">
                                </object>
                                <kt-img-magnifier v-else class="mb-4"
                                                  :src="images_url.birth_certificate_first_page_of_first_sh"
                                ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col v-if="form_data.customer_detail.customer_type_id==customerType.LEGAL" lg="4" md="4"
                                xs="12">
                            <kt-col
                                    lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="birth_certificate_first_page_of_second_sh">
                                        {{ $t('pos.document.birth_certificate_first_page_of_second_sh') }}
                                    </kt-form-label>
                                    <kt-form-label for="birth_certificate_first_page_of_second_sh"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input v-if="can_change_documents"
                                           @change="processFile($event)"
                                           type="file"
                                           id="birth_certificate_first_page_of_second_sh"
                                           name="birth_certificate_first_page_of_second_sh"
                                           class="custom-file-upload"
                                           accept=".jpg,.jpeg,.pdf,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="images_url.birth_certificate_first_page_of_second_sh &&
                             wizard.document_operation == manageDocuments.UPLOAD"
                                 class="custom-control custom-checkbox special-tooltip"
                                 style="position:relative;right: 5%;top:0%;display: inline">
                                <input type="checkbox" class="custom-control-input"
                                       id="birth_certificate_first_page_of_second_sh_checkbox"
                                       name="birth_certificate_first_page_of_second_sh"
                                       v-model="checkboxes.birth_certificate_first_page_of_second_sh"
                                >
                                <span class="tooltip-text" style="right: -80%">{{ $t('pos.statuses.Switch') }}</span>
                                <label class="custom-control-label"
                                       id="birth_certificate_first_page_of_second_sh_checkbox_label"
                                       for="birth_certificate_first_page_of_second_sh_checkbox"></label>
                            </div>
                            <div v-show="images_url.birth_certificate_first_page_of_second_sh&& show_delete_icon"
                                 style="position:relative;right: 80%;top:0%;display: inline"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('birth_certificate_first_page_of_second_sh')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <div v-show="images_url.birth_certificate_first_page_of_second_sh && $can('manage','pos')"
                                 style="position:relative;right: 6%;top:-1%;display: inline">
                                <span :class="document_classes.birth_certificate_first_page_of_second_sh"
                                      v-if="wizard.document_operation == manageDocuments.UPLOAD && form_data.documents.birth_certificate_first_page_of_second_sh.status"
                                      @click="show_rejection_reasons('birth_certificate_first_page_of_second_sh')"
                                >{{ form_data.documents.birth_certificate_first_page_of_second_sh.status_str }}</span>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="images_url.birth_certificate_first_page_of_second_sh">
                                <object v-if="image_type_view.birth_certificate_first_page_of_second_sh == documentFormat.PDF"
                                        style="position: relative;height: 300px!important;width: 100%"

                                        :data="images_url.birth_certificate_first_page_of_second_sh"
                                        type="application/pdf">
                                </object>
                                <kt-img-magnifier v-else class="mb-4"
                                                  :src="images_url.birth_certificate_first_page_of_second_sh"
                                ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col v-if="form_data.customer_detail.customer_type_id==customerType.LEGAL" lg="4" md="4"
                                xs="12">
                            <kt-col
                                    lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="national_card_of_first_sh">
                                        {{ $t('pos.document.national_card_of_first_sh') }}
                                    </kt-form-label>
                                    <kt-form-label for="national_card_of_first_sh"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input v-if="can_change_documents"
                                           @change="processFile($event)"
                                           type="file"
                                           id="national_card_of_first_sh"
                                           name="national_card_of_first_sh"
                                           class="custom-file-upload"
                                           accept=".jpg,.jpeg,.pdf,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="images_url.national_card_of_first_sh &&
                             wizard.document_operation == manageDocuments.UPLOAD"
                                 class="custom-control custom-checkbox special-tooltip"
                                 style="position:relative;right: 5%;top:0%;display: inline">
                                <input type="checkbox" class="custom-control-input"
                                       id="national_card_of_first_sh_checkbox"
                                       name="national_card_of_first_sh"
                                       v-model="checkboxes.national_card_of_first_sh"
                                >
                                <span class="tooltip-text" style="right: -80%">{{ $t('pos.statuses.Switch') }}</span>
                                <label class="custom-control-label" id="national_card_of_first_sh_checkbox_label"
                                       for="national_card_of_first_sh_checkbox"></label>
                            </div>
                            <div v-show="images_url.national_card_of_first_sh&& show_delete_icon"
                                 style="position:relative;right: 80%;top:0%;display: inline"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('national_card_of_first_sh')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <div v-show="images_url.national_card_of_first_sh && $can('manage','pos')"
                                 style="position:relative;right: 6%;top:-1%;display: inline">
                                <span :class="document_classes.national_card_of_first_sh"
                                      v-if="wizard.document_operation == manageDocuments.UPLOAD && form_data.documents.national_card_of_first_sh.status"
                                      @click="show_rejection_reasons('national_card_of_first_sh')"
                                >{{ form_data.documents.national_card_of_first_sh.status_str }}</span>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="images_url.national_card_of_first_sh">
                                <object v-if="image_type_view.national_card_of_first_sh == documentFormat.PDF"
                                        style="position: relative;height: 300px!important;width: 100%"
                                        :data="images_url.national_card_of_first_sh" type="application/pdf">
                                </object>
                                <kt-img-magnifier v-else class="mb-4"
                                                  :src="images_url.national_card_of_first_sh"
                                ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col v-if="form_data.customer_detail.customer_type_id==customerType.LEGAL" lg="4" md="4"
                                xs="12">
                            <kt-col
                                    lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="national_card_of_second_sh">
                                        {{ $t('pos.document.national_card_of_second_sh') }}
                                    </kt-form-label>
                                    <kt-form-label for="national_card_of_second_sh"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input v-if="can_change_documents"
                                           @change="processFile($event)"
                                           type="file"
                                           id="national_card_of_second_sh"
                                           name="national_card_of_second_sh"
                                           class="custom-file-upload"
                                           accept=".jpg,.jpeg,.pdf,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="images_url.national_card_of_second_sh &&
                            wizard.document_operation == manageDocuments.UPLOAD"
                                 class="custom-control custom-checkbox special-tooltip"
                                 style="position:relative;right: 5%;top:0%;display: inline">
                                <input type="checkbox" class="custom-control-input"
                                       id="national_card_of_second_sh_checkbox"
                                       name="national_card_of_second_sh"
                                       v-model="checkboxes.national_card_of_second_sh"
                                >
                                <span class="tooltip-text" style="right: -80%">{{ $t('pos.statuses.Switch') }}</span>
                                <label class="custom-control-label" id="national_card_of_second_sh_label"
                                       for="national_card_of_second_sh_checkbox"></label>
                            </div>
                            <div v-show="images_url.national_card_of_second_sh&& show_delete_icon"
                                 style="position:relative;right: 80%;top:0%;display: inline"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('national_card_of_second_sh')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <div v-show="images_url.national_card_of_second_sh && $can('manage','pos')"
                                 style="position:relative;right: 6%;top:-1%;display: inline">
                                <span :class="document_classes.national_card_of_second_sh"
                                      v-if="wizard.document_operation == manageDocuments.UPLOAD && form_data.documents.national_card_of_second_sh.status"
                                      @click="show_rejection_reasons('national_card_of_second_sh')"
                                >{{ form_data.documents.national_card_of_second_sh.status_str }}</span>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="images_url.national_card_of_second_sh">
                                <object v-if="image_type_view.national_card_of_second_sh == documentFormat.PDF"
                                        style="position: relative;height: 300px!important;width: 100%"
                                        :data="images_url.national_card_of_second_sh" type="application/pdf">
                                </object>
                                <kt-img-magnifier v-else class="mb-4"
                                                  :src="images_url.national_card_of_second_sh"
                                ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>

                        <kt-col v-if="!form_data.customer_detail.is_foreign_nationals" lg="4" md="4" xs="12">
                            <kt-col
                                    lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="national_card">
                                        {{ $t('pos.document.national_card') }}
                                    </kt-form-label>
                                    <kt-form-label for="national_card_img"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input v-if="can_change_documents"
                                           @change="processFile($event)"
                                           type="file"
                                           id="national_card_img"
                                           name="national_card_img"
                                           class="custom-file-upload"
                                           accept=".jpg,.jpeg,.pdf,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="images_url.national_card_img && wizard.document_operation == manageDocuments.UPLOAD"
                                 class="custom-control custom-checkbox special-tooltip"
                                 style="position:relative;right: 5%;top:0%;display: inline">
                                <input type="checkbox" class="custom-control-input" id="national_card_img_checkbox"
                                       name="national_card_img"
                                       v-model="checkboxes.national_card_img"
                                >
                                <span class="tooltip-text" style="right: -80%">{{ $t('pos.statuses.Switch') }}</span>
                                <label class="custom-control-label" id="national_card_img_checkbox_label"
                                       for="national_card_img_checkbox"></label>
                            </div>
                            <div v-show="images_url.national_card_img && show_delete_icon"
                                 style="position:relative;right: 80%;top:0%;display: inline"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('national_card_img')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <div v-show="images_url.national_card_img && $can('manage','pos')"
                                 style="position:relative;right: 6%;top:-1%;display: inline">
                                <span :class="document_classes.national_card_img"
                                      v-if="wizard.document_operation == manageDocuments.UPLOAD && form_data.documents.national_card_img.status"
                                      @click="show_rejection_reasons('national_card_img')"
                                >{{ form_data.documents.national_card_img.status_str }}</span>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="images_url.national_card_img">
                                <object v-if="image_type_view.national_card_img == documentFormat.PDF"
                                        style="position: relative;height: 300px!important;width: 100%"
                                        :data="images_url.national_card_img" type="application/pdf">
                                </object>
                                <kt-img-magnifier v-else height="15px"
                                                  :src="images_url.national_card_img"></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col v-if="!form_data.customer_detail.is_foreign_nationals" lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="birth_certificate_card_img">
                                        {{ $t('pos.document.birth_certificate_card') }}
                                    </kt-form-label>
                                    <kt-form-label for="birth_certificate_card_img"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input v-if="can_change_documents"
                                           @change="processFile($event)"
                                           type="file"
                                           id="birth_certificate_card_img"
                                           name="birth_certificate_card_img"
                                           class="custom-file-upload"
                                           accept=".jpg,.jpeg,.pdf,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="images_url.birth_certificate_card_img &&
                             wizard.document_operation == manageDocuments.UPLOAD"
                                 class="custom-control custom-checkbox special-tooltip"
                                 style="position:relative;right: 5%;top:0%;display: inline">
                                <input type="checkbox" class="custom-control-input"
                                       id="birth_certificate_card_img_checkbox"
                                       name="birth_certificate_card_img"
                                       v-model="checkboxes.birth_certificate_card_img"
                                >
                                <span class="tooltip-text" style="right: -80%">{{ $t('pos.statuses.Switch') }}</span>
                                <label class="custom-control-label" id="birth_certificate_card_img_label"
                                       for="birth_certificate_card_img_checkbox"></label>
                            </div>
                            <div v-show="images_url.birth_certificate_card_img && show_delete_icon"
                                 style="position:relative;right: 80%;top:0%;display: inline"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('birth_certificate_card_img')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <div v-show="images_url.birth_certificate_card_img  && $can('manage','pos')"
                                 style="position:relative;right: 6%;top:-1%;display: inline">
                                <span :class="document_classes.birth_certificate_card_img"
                                      v-if="wizard.document_operation == manageDocuments.UPLOAD && form_data.documents.birth_certificate_card_img.status"
                                      @click="show_rejection_reasons('birth_certificate_card_img')"
                                >{{ form_data.documents.birth_certificate_card_img.status_str }}</span>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="images_url.birth_certificate_card_img">
                                <object v-if="image_type_view.birth_certificate_card_img == documentFormat.PDF"
                                        style="position: relative;height: 300px!important;width: 100%"
                                        :data="images_url.birth_certificate_card_img" type="application/pdf">
                                </object>
                                <kt-img-magnifier v-else class="mb-4"
                                                  :src="images_url.birth_certificate_card_img"
                                ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col lg="4" md="4" xs="12">
                            <kt-col
                                    lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="delegation_of_authority_national_card">
                                        {{ $t('pos.document.delegation_of_authority_national_card') }}
                                    </kt-form-label>
                                    <kt-form-label for="delegation_of_authority_national_card"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input v-if="can_change_documents"
                                           @change="processFile($event)"
                                           type="file"
                                           id="delegation_of_authority_national_card"
                                           name="delegation_of_authority_national_card"
                                           class="custom-file-upload"
                                           accept=".jpg,.jpeg,.pdf,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="images_url.delegation_of_authority_national_card
                             && wizard.document_operation == manageDocuments.UPLOAD"
                                 class="custom-control custom-checkbox special-tooltip"
                                 style="position:relative;right: 5%;top:0%;display: inline">
                                <input type="checkbox" class="custom-control-input"
                                       id="delegation_of_authority_national_card_checkbox"
                                       name="delegation_of_authority_national_card"
                                       v-model="checkboxes.delegation_of_authority_national_card"
                                >
                                <span class="tooltip-text" style="right: -80%">{{ $t('pos.statuses.Switch') }}</span>
                                <label class="custom-control-label" id="delegation_of_authority_national_card_label"
                                       for="delegation_of_authority_national_card_checkbox"></label>
                            </div>
                            <div v-show="images_url.delegation_of_authority_national_card && show_delete_icon"
                                 style="position:relative;right: 80%;top:0%;display: inline"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('delegation_of_authority_national_card')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <div v-show="images_url.delegation_of_authority_national_card && $can('manage','pos')"
                                 style="position:relative;right: 6%;top:-1%;display: inline">
                                <span :class="document_classes.delegation_of_authority_national_card"
                                      v-if="wizard.document_operation == manageDocuments.UPLOAD && form_data.documents.delegation_of_authority_national_card.status"
                                      @click="show_rejection_reasons('delegation_of_authority_national_card')"
                                >{{ form_data.documents.delegation_of_authority_national_card.status_str }}</span>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="images_url.delegation_of_authority_national_card">
                                <object v-if="image_type_view.delegation_of_authority_national_card == documentFormat.PDF"
                                        style="position: relative;height: 300px!important;width: 100%"
                                        :data="images_url.delegation_of_authority_national_card" type="application/pdf">
                                </object>
                                <kt-img-magnifier v-else class="mb-4"
                                                  :src="images_url.delegation_of_authority_national_card"
                                ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="card_acceptance_contract">
                                        {{ $t('pos.document.card_acceptance_contract') }}
                                    </kt-form-label>
                                    <kt-form-label for="card_acceptance_contract"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input v-if="can_change_documents"
                                           @change="processFile($event)"
                                           type="file"
                                           id="card_acceptance_contract"
                                           name="card_acceptance_contract"
                                           class="custom-file-upload"
                                           accept=".jpg,.jpeg,.pdf,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="images_url.card_acceptance_contract && wizard.document_operation == manageDocuments.UPLOAD"
                                 class="custom-control custom-checkbox special-tooltip"
                                 style="position:relative;right: 5%;top:0%;display: inline">
                                <input type="checkbox" class="custom-control-input"
                                       id="card_acceptance_contract_checkbox"
                                       name="iban_certificate"
                                       v-model="checkboxes.card_acceptance_contract"
                                >
                                <span class="tooltip-text" style="right: -80%">{{ $t('pos.statuses.Switch') }}</span>
                                <label class="custom-control-label" id="card_acceptance_contract_label"
                                       for="card_acceptance_contract_checkbox"></label>
                            </div>
                            <div v-show=" images_url.card_acceptance_contract && show_delete_icon"
                                 style="position:relative;right: 80%;top:0%;display: inline"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('card_acceptance_contract')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <div v-show="images_url.card_acceptance_contract && $can('manage','pos')"
                                 style="position:relative;right: 6%;top:-1%;display: inline">
                                <span :class="document_classes.card_acceptance_contract"
                                      v-if="wizard.document_operation == manageDocuments.UPLOAD && form_data.documents.card_acceptance_contract.status"
                                      @click="show_rejection_reasons('card_acceptance_contract')"
                                >{{ form_data.documents.card_acceptance_contract.status_str }}</span>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="images_url.card_acceptance_contract">
                                <object v-if="image_type_view.card_acceptance_contract == documentFormat.PDF"
                                        style="position: relative;height: 300px!important;width: 100%"
                                        :data="images_url.card_acceptance_contract" type="application/pdf">
                                </object>
                                <kt-img-magnifier v-else class="mb-4"
                                                  :src="images_url.card_acceptance_contract"
                                ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="iban_certificate">
                                        {{ $t('pos.document.iban_certificate') }}
                                    </kt-form-label>
                                    <kt-form-label for="iban_certificate"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input v-if="can_change_documents"
                                           @change="processFile($event)"
                                           type="file"
                                           id="iban_certificate"
                                           name="iban_certificate"
                                           class="custom-file-upload"
                                           accept=".jpg,.jpeg,.pdf,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="images_url.iban_certificate && wizard.document_operation == manageDocuments.UPLOAD"
                                 class="custom-control custom-checkbox special-tooltip"
                                 style="position:relative;right: 5%;top:0%;display: inline">
                                <input type="checkbox" class="custom-control-input" id="iban_certificate_checkbox"
                                       name="iban_certificate"
                                       v-model="checkboxes.iban_certificate"
                                >
                                <span class="tooltip-text" style="right: -80%">{{ $t('pos.statuses.Switch') }}</span>
                                <label class="custom-control-label" id="iban_certificate_label"
                                       for="iban_certificate_checkbox"></label>
                            </div>
                            <div v-show=" images_url.iban_certificate && show_delete_icon"
                                 style="position:relative;right: 80%;top:0%;display: inline"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('iban_certificate')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <div v-show="images_url.iban_certificate && $can('manage','pos')"
                                 style="position:relative;right: 6%;top:-1%;display: inline">
                                <span :class="document_classes.iban_certificate"
                                      v-if="wizard.document_operation == manageDocuments.UPLOAD && form_data.documents.iban_certificate.status"
                                      @click="show_rejection_reasons('iban_certificate')"
                                >{{ form_data.documents.iban_certificate.status_str }}</span>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="images_url.iban_certificate">
                                <object v-if="image_type_view.iban_certificate == documentFormat.PDF"
                                        style="position: relative;height: 300px!important;width: 100%"
                                        :data="images_url.iban_certificate" type="application/pdf">
                                </object>
                                <kt-img-magnifier v-else class="mb-4"
                                                  :src="images_url.iban_certificate"
                                ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="change_iban_form">
                                        {{ $t('pos.document.change_iban_form') }}
                                    </kt-form-label>
                                    <kt-form-label for="change_iban_form"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input v-if="can_change_documents"
                                           @change="processFile($event)"
                                           type="file"
                                           id="change_iban_form"
                                           name="change_iban_form"
                                           class="custom-file-upload"
                                           accept=".jpg,.jpeg,.pdf,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="images_url.change_iban_form && wizard.document_operation == manageDocuments.UPLOAD"
                                 class="custom-control custom-checkbox special-tooltip"
                                 style="position:relative;right: 5%;top:0%;display: inline">
                                <input type="checkbox" class="custom-control-input" id="change_iban_form_checkbox"
                                       name="change_iban_form"
                                       v-model="checkboxes.change_iban_form"
                                >
                                <span class="tooltip-text" style="right: -80%">{{ $t('pos.statuses.Switch') }}</span>
                                <label class="custom-control-label" id="change_iban_form_label"
                                       for="change_iban_form_checkbox"></label>
                            </div>
                            <div v-show="images_url.change_iban_form && show_delete_icon"
                                 style="position:relative;right: 80%;top:0%;display: inline"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('change_iban_form')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <div v-show="images_url.change_iban_form && $can('manage','pos')"
                                 style="position:relative;right: 6%;top:-1%;display: inline">
                                <span :class="document_classes.change_iban_form"
                                      v-if="wizard.document_operation == manageDocuments.UPLOAD && form_data.documents.change_iban_form.status"
                                      @click="show_rejection_reasons('change_iban_form')"
                                >{{ form_data.documents.change_iban_form.status_str }}</span>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="images_url.change_iban_form">
                                <object v-if="image_type_view.change_iban_form == documentFormat.PDF"
                                        style="position: relative;height: 300px!important;width: 100%"
                                        :data="images_url.change_iban_form" type="application/pdf">
                                </object>
                                <kt-img-magnifier v-else class="mb-4"
                                                  :src="images_url.change_iban_form"
                                ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="installation_form">
                                        {{ $t('pos.document.installation_form') }}
                                    </kt-form-label>
                                    <kt-form-label for="installation_form"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input v-if="can_change_documents"
                                           @change="processFile($event)"
                                           type="file"
                                           id="installation_form"
                                           name="installation_form"
                                           class="custom-file-upload"
                                           accept=".jpg,.jpeg,.pdf,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="images_url.installation_form && wizard.document_operation == manageDocuments.UPLOAD"
                                 class="custom-control custom-checkbox special-tooltip"
                                 style="position:relative;right: 5%;top:0%;display: inline">
                                <input type="checkbox" class="custom-control-input" id="installation_form_checkbox"
                                       name="installation_form"
                                       v-model="checkboxes.installation_form"
                                >
                                <span class="tooltip-text" style="right: -80%">{{ $t('pos.statuses.Switch') }}</span>
                                <label class="custom-control-label" id="installation_form_checkbox_label"
                                       for="installation_form_checkbox"></label>
                            </div>
                            <div v-show="images_url.installation_form && show_delete_icon"
                                 style="position:relative;right: 80%;top:0%;display: inline"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('installation_form')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <div v-show="images_url.installation_form && $can('manage','pos')"
                                 style="position:relative;right: 6%;top:-1%;display: inline">
                                <span :class="document_classes.installation_form"
                                      v-if="wizard.document_operation == manageDocuments.UPLOAD && form_data.documents.installation_form.status"
                                      @click="show_rejection_reasons('installation_form')"
                                >{{ form_data.documents.installation_form.status_str }}</span>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="images_url.installation_form">
                                <object v-if="image_type_view.installation_form == documentFormat.PDF"
                                        style="position: relative;height: 300px!important;width: 100%"
                                        :data="images_url.installation_form" type="application/pdf">
                                </object>
                                <kt-img-magnifier v-else class="mb-4"
                                                  :src="images_url.installation_form"
                                ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col lg="4" md="4" xs="12">
                            <kt-col
                                    lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="deposit_receipt">
                                        {{ $t('pos.document.deposit_receipt') }}
                                    </kt-form-label>
                                    <kt-form-label for="deposit_receipt"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input v-if="can_change_documents"
                                           @change="processFile($event)"
                                           type="file"
                                           id="deposit_receipt"
                                           name="deposit_receipt"
                                           class="custom-file-upload"
                                           accept=".jpg,.jpeg,.pdf,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="images_url.deposit_receipt && wizard.document_operation == manageDocuments.UPLOAD"
                                 class="custom-control custom-checkbox special-tooltip"
                                 style="position:relative;right: 5%;top:0%;display: inline">
                                <input type="checkbox" class="custom-control-input" id="deposit_receipt_checkbox"
                                       name="deposit_receipt"
                                       v-model="checkboxes.deposit_receipt"
                                >
                                <span class="tooltip-text" style="right: -80%">{{ $t('pos.statuses.Switch') }}</span>
                                <label class="custom-control-label" id="deposit_receipt_checkbox_label"
                                       for="deposit_receipt_checkbox"></label>
                            </div>
                            <div v-show="images_url.deposit_receipt && show_delete_icon"
                                 style="position:relative;right: 80%;top:0%;display: inline"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('deposit_receipt')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <div v-show="images_url.deposit_receipt && $can('manage','pos')"
                                 style="position:relative;right: 6%;top:-1%;display: inline">
                                <span :class="document_classes.deposit_receipt"
                                      v-if="wizard.document_operation == manageDocuments.UPLOAD && form_data.documents.deposit_receipt.status"
                                      @click="show_rejection_reasons('deposit_receipt')"
                                >{{ form_data.documents.deposit_receipt.status_str }}</span>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="images_url.deposit_receipt">
                                <object v-if="image_type_view.deposit_receipt == documentFormat.PDF"
                                        style="position: relative;height: 300px!important;width: 100%"
                                        :data="images_url.deposit_receipt" type="application/pdf">
                                </object>
                                <kt-img-magnifier v-else class="mb-4"
                                                  :src="images_url.deposit_receipt"
                                ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="phone_bill">
                                        {{ $t('pos.document.phone_bill') }}
                                    </kt-form-label>
                                    <kt-form-label for="phone_bill"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input v-if="can_change_documents"
                                           @change="processFile($event)"
                                           type="file"
                                           id="phone_bill"
                                           name="phone_bill"
                                           class="custom-file-upload"
                                           accept=".jpg,.jpeg,.pdf,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="images_url.phone_bill && wizard.document_operation == manageDocuments.UPLOAD"
                                 class="custom-control custom-checkbox special-tooltip"
                                 style="position:relative;right: 5%;top:0%;display: inline">
                                <input type="checkbox" class="custom-control-input" id="phone_bill_checkbox"
                                       name="phone_bill"
                                       v-model="checkboxes.phone_bill"
                                >
                                <span class="tooltip-text" style="right: -80%">{{ $t('pos.statuses.Switch') }}</span>
                                <label class="custom-control-label" id="phone_bill_checkbox_label"
                                       for="phone_bill_checkbox"></label>
                            </div>
                            <div v-show="images_url.phone_bill && show_delete_icon"
                                 style="position:relative;right: 80%;top:0%;display: inline"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('phone_bill')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <div v-show="images_url.phone_bill && $can('manage','pos')"
                                 style="position:relative;right: 6%;top:-1%;display: inline">
                                <span :class="document_classes.phone_bill"
                                      v-if="wizard.document_operation == manageDocuments.UPLOAD && form_data.documents.phone_bill.status"
                                      @click="show_rejection_reasons('phone_bill')"
                                >{{ form_data.documents.phone_bill.status_str }}</span>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="images_url.phone_bill">
                                <object v-if="image_type_view.phone_bill == documentFormat.PDF"
                                        style="position: relative;height: 300px!important;width: 100%"
                                        :data="images_url.phone_bill" type="application/pdf">
                                </object>
                                <kt-img-magnifier v-else class="mb-4"
                                                  :src="images_url.phone_bill"
                                ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="renting_or_ownership_document">
                                        {{ $t('pos.document.renting_or_ownership_document') }}
                                    </kt-form-label>
                                    <kt-form-label for="renting_or_ownership_document"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input v-if="can_change_documents"
                                           @change="processFile($event)"
                                           type="file"
                                           id="renting_or_ownership_document"
                                           name="renting_or_ownership_document"
                                           class="custom-file-upload"
                                           accept=".jpg,.jpeg,.pdf,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="images_url.renting_or_ownership_document && wizard.document_operation == manageDocuments.UPLOAD"
                                 class="custom-control custom-checkbox special-tooltip"
                                 style="position:relative;right: 5%;top:0%;display: inline">
                                <input type="checkbox" class="custom-control-input"
                                       id="renting_or_ownership_document_checkbox"
                                       name="renting_or_ownership_document"
                                       v-model="checkboxes.renting_or_ownership_document"
                                >
                                <span class="tooltip-text" style="right: -80%">{{ $t('pos.statuses.Switch') }}</span>
                                <label class="custom-control-label" id="renting_or_ownership_document_checkbox_label"
                                       for="renting_or_ownership_document_checkbox"></label>
                            </div>
                            <div v-show="images_url.renting_or_ownership_document && show_delete_icon"
                                 style="position:relative;right: 80%;top:0%;display: inline"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('renting_or_ownership_document')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <div v-show="images_url.renting_or_ownership_document && $can('manage','pos')"
                                 style="position:relative;right: 6%;top:-1%;display: inline">
                                <span :class="document_classes.renting_or_ownership_document"
                                      v-if="wizard.document_operation == manageDocuments.UPLOAD && form_data.documents.renting_or_ownership_document.status"
                                      @click="show_rejection_reasons('renting_or_ownership_document')"
                                >{{ form_data.documents.renting_or_ownership_document.status_str }}</span>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="images_url.renting_or_ownership_document">
                                <object v-if="image_type_view.renting_or_ownership_document == documentFormat.PDF"
                                        style="position: relative;height: 300px!important;width: 100%"
                                        :data="images_url.renting_or_ownership_document" type="application/pdf">
                                </object>
                                <kt-img-magnifier v-else class="mb-4"
                                                  :src="images_url.renting_or_ownership_document"
                                ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="business_license_img">
                                        {{ $t('pos.document.business_license') }}
                                    </kt-form-label>
                                    <kt-form-label for="business_license_img"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input v-if="can_change_documents"
                                           @change="processFile($event)"
                                           type="file"
                                           id="business_license_img"
                                           name="business_license_img"
                                           class="custom-file-upload"
                                           accept=".jpg,.jpeg,.pdf,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="images_url.business_license_img && wizard.document_operation == manageDocuments.UPLOAD"
                                 class="custom-control custom-checkbox special-tooltip"
                                 style="position:relative;right: 5%;top:0%;display: inline">
                                <input type="checkbox" class="custom-control-input" id="business_license_img_checkbox"
                                       name="business_license_img"
                                       v-model="checkboxes.business_license_img"
                                >
                                <span class="tooltip-text" style="right: -80%">{{ $t('pos.statuses.Switch') }}</span>
                                <label class="custom-control-label" id="business_license_img_checkbox_label"
                                       for="business_license_img_checkbox"></label>
                            </div>
                            <div v-show="images_url.business_license_img && show_delete_icon"
                                 style="position:relative;right: 80%;top:0%;display: inline"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('business_license_img')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <div v-show="images_url.business_license_img && $can('manage','pos')"
                                 style="position:relative;right: 6%;top:-1%;display: inline">
                                <span :class="document_classes.business_license_img"
                                      v-if="wizard.document_operation == manageDocuments.UPLOAD && form_data.documents.business_license_img.status"
                                      @click="show_rejection_reasons('business_license_img')"
                                >{{ form_data.documents.business_license_img.status_str }}</span>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="images_url.business_license_img">
                                <object v-if="image_type_view.business_license_img == documentFormat.PDF"
                                        style="position: relative;height: 300px!important;width: 100%"
                                        :data="images_url.business_license_img" type="application/pdf">
                                </object>
                                <kt-img-magnifier v-else class="mb-4"
                                                  :src="images_url.business_license_img"
                                ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="delegation_of_authority_form">
                                        {{ $t('pos.document.delegation_of_authority_form') }}
                                    </kt-form-label>
                                    <kt-form-label for="delegation_of_authority_form"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input v-if="can_change_documents"
                                           @change="processFile($event)"
                                           type="file"
                                           id="delegation_of_authority_form"
                                           name="delegation_of_authority_form"
                                           class="custom-file-upload"
                                           accept=".jpg,.jpeg,.pdf,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="images_url.delegation_of_authority_form && wizard.document_operation == manageDocuments.UPLOAD"
                                 class="custom-control custom-checkbox special-tooltip"
                                 style="position:relative;right: 5%;top:0%;display: inline">
                                <input type="checkbox" class="custom-control-input"
                                       id="delegation_of_authority_form_checkbox"
                                       name="delegation_of_authority_form"
                                       v-model="checkboxes.delegation_of_authority_form"
                                >
                                <span class="tooltip-text" style="right: -80%">{{ $t('pos.statuses.Switch') }}</span>
                                <label class="custom-control-label" id="delegation_of_authority_form_checkbox_label"
                                       for="delegation_of_authority_form_checkbox"></label>
                            </div>
                            <div v-show="images_url.delegation_of_authority_form && show_delete_icon"
                                 style="position:relative;right: 80%;top:0%;display: inline"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('delegation_of_authority_form')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <div v-show="images_url.delegation_of_authority_form && $can('manage','pos')"
                                 style="position:relative;right: 6%;top:-1%;display: inline">
                                <span :class="document_classes.delegation_of_authority_form"
                                      v-if="wizard.document_operation == manageDocuments.UPLOAD && form_data.documents.delegation_of_authority_form.status"
                                      @click="show_rejection_reasons('delegation_of_authority_form')"
                                >{{ form_data.documents.delegation_of_authority_form.status_str }}</span>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="images_url.delegation_of_authority_form">
                                <object v-if="image_type_view.delegation_of_authority_form == documentFormat.PDF"
                                        style="position: relative;height: 300px!important;width: 100%"
                                        :data="images_url.delegation_of_authority_form" type="application/pdf">
                                </object>
                                <kt-img-magnifier v-else class="mb-4"
                                                  :src="images_url.delegation_of_authority_form"
                                ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col lg="4" md="4" xs="12">
                            <kt-col
                                    lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="certificate_form">
                                        {{ $t('pos.document.certificate') }}
                                    </kt-form-label>
                                    <kt-form-label for="certificate_form"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input v-if="can_change_documents"
                                           @change="processFile($event)"
                                           type="file"
                                           id="certificate_form"
                                           name="certificate_form"
                                           class="custom-file-upload"
                                           accept=".jpg,.jpeg,.pdf,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="images_url.certificate_form && wizard.document_operation == manageDocuments.UPLOAD"
                                 class="custom-control custom-checkbox special-tooltip"
                                 style="position:relative;right: 5%;top:0%;display: inline">
                                <input type="checkbox" class="custom-control-input" id="certificate_form_checkbox"
                                       name="certificate_form"
                                       v-model="checkboxes.certificate_form"
                                >
                                <span class="tooltip-text" style="right: -80%">{{ $t('pos.statuses.Switch') }}</span>
                                <label class="custom-control-label" id="certificate_form_checkbox_label"
                                       for="certificate_form_checkbox"></label>
                            </div>
                            <div v-show="images_url.certificate_form && show_delete_icon"
                                 style="position:relative;right: 80%;top:0%;display: inline"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('certificate_form')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <div v-show="images_url.certificate_form && $can('manage','pos')"
                                 style="position:relative;right: 6%;top:-1%;display: inline">
                                <span :class="document_classes.certificate_form"
                                      v-if="wizard.document_operation == manageDocuments.UPLOAD && form_data.documents.certificate_form.status"
                                      @click="show_rejection_reasons('certificate_form')"
                                >{{ form_data.documents.certificate_form.status_str }}</span>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="images_url.certificate_form">
                                <object v-if="image_type_view.certificate_form == documentFormat.PDF"
                                        style="position: relative;height: 300px!important;width: 100%"
                                        :data="images_url.certificate_form" type="application/pdf">
                                </object>
                                <kt-img-magnifier v-else class="mb-4"
                                                  :src="images_url.certificate_form"
                                ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col v-if="form_data.customer_detail.is_foreign_nationals" lg="4" md="4" xs="12">
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="amayesh_card_img">
                                        {{ $t('pos.document.amayesh_card') }}
                                    </kt-form-label>
                                    <kt-form-label for="amayesh_card_img"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input v-if="can_change_documents"
                                           @change="processFile($event)"
                                           type="file"
                                           id="amayesh_card_img"
                                           name="amayesh_card_img"
                                           class="custom-file-upload"
                                           accept=".jpg,.jpeg,.pdf,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="images_url.amayesh_card_img && wizard.document_operation == manageDocuments.UPLOAD"
                                 class="custom-control custom-checkbox special-tooltip"
                                 style="position:relative;right: 5%;top:0%;display: inline">
                                <input type="checkbox" class="custom-control-input" id="amayesh_card_img_checkbox"
                                       name="amayesh_card_img"
                                       v-model="checkboxes.amayesh_card_img"
                                >
                                <span class="tooltip-text" style="right: -80%">{{ $t('pos.statuses.Switch') }}</span>
                                <label class="custom-control-label" id="amayesh_card_img_checkbox_label"
                                       for="amayesh_card_img_checkbox"></label>
                            </div>
                            <div v-show="images_url.amayesh_card_img && show_delete_icon"
                                 style="position:relative;right: 80%;top:0%;display: inline"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('amayesh_card_img')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <div v-show="images_url.amayesh_card_img && $can('manage','pos')"
                                 style="position:relative;right: 6%;top:-1%;display: inline">
                                <span :class="document_classes.amayesh_card_img"
                                      v-if="wizard.document_operation == manageDocuments.UPLOAD && form_data.documents.amayesh_card_img.status"
                                      @click="show_rejection_reasons('amayesh_card_img')"
                                >{{ form_data.documents.amayesh_card_img.status_str }}</span>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="images_url.amayesh_card_img">
                                <object v-if="image_type_view.amayesh_card_img == documentFormat.PDF"
                                        style="position: relative;height: 300px!important;width: 100%"
                                        :data="images_url.amayesh_card_img" type="application/pdf">
                                </object>
                                <kt-img-magnifier v-else class="mb-4"
                                                  :src="images_url.amayesh_card_img"
                                ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                        <kt-col v-if="form_data.customer_detail.is_foreign_nationals" lg="4" md="4" xs="12">
                            <kt-col
                                    lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="passport_img">
                                        {{ $t('pos.document.passport_img') }}
                                    </kt-form-label>
                                    <kt-form-label for="passport_img"
                                                   class="d-block btn btn-secondary btn-wide label-file">
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ $t('pos.click_me') }}
                                    </kt-form-label>
                                    <input v-if="can_change_documents"
                                           @change="processFile($event)"
                                           type="file"
                                           id="passport_img"
                                           name="passport_img"
                                           class="custom-file-upload"
                                           accept=".jpg,.jpeg,.pdf,image/png"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <div v-show="images_url.passport_img && wizard.document_operation == manageDocuments.UPLOAD"
                                 class="custom-control custom-checkbox special-tooltip"
                                 style="position:relative;right: 5%;top:0%;display: inline">
                                <input type="checkbox" class="custom-control-input" id="passport_img_checkbox"
                                       name="passport_img"
                                       v-model="checkboxes.passport_img"
                                >
                                <span class="tooltip-text" style="right: -80%">{{ $t('pos.statuses.Switch') }}</span>
                                <label class="custom-control-label" id="passport_img_checkbox_label"
                                       for="passport_img_checkbox"></label>
                            </div>
                            <div v-show="images_url.passport_img && show_delete_icon"
                                 style="position:relative;right: 80%;top:0%;display: inline"
                                 class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <span class="tooltip-text">{{ $t('btn.delete') }}</span>
                                <i @click="deleteFile('passport_img')" class="fa fa-trash"
                                   style="font-size: 14px;color: #9c0f1e"></i>
                            </div>
                            <div v-show="images_url.passport_img && $can('manage','pos')"
                                 style="position:relative;right: 6%;top:-1%;display: inline">
                                <span :class="document_classes.passport_img"
                                      v-if="wizard.document_operation == manageDocuments.UPLOAD && form_data.documents.passport_img.status"
                                      @click="show_rejection_reasons('passport_img')"
                                >{{ form_data.documents.passport_img.status_str }}</span>
                            </div>
                            <kt-col lg="12" md="12" xs="12"
                                    v-show="images_url.passport_img">
                                <object v-if="image_type_view.passport_img == documentFormat.PDF"
                                        style="position: relative;height: 300px!important;width: 100%"
                                        :data="images_url.passport_img" type="application/pdf">
                                </object>
                                <kt-img-magnifier v-else class="mb-4"
                                                  :src="images_url.passport_img"
                                ></kt-img-magnifier>
                            </kt-col>
                            <hr>
                        </kt-col>
                    </kt-row>
                    <kt-row v-if="wizard.document_operation == manageDocuments.UPLOAD" style="margin-top:50px">
                        <kt-col lg="4" md="4" xs="4">
                            <div
                                    class="custom-control custom-checkbox"
                                    style="position:relative;right: 5%;top:0%;display: inline">
                                <input type="checkbox" class="custom-control-input" id="select_all"
                                       name="select_all"
                                       v-model="select_all"
                                >
                                <label class="custom-control-label" id="select_all_label"
                                       for="select_all">{{ $t('selectpicker.select_all') }}</label>
                            </div>
                        </kt-col>
                        <kt-col lg="4" md="4" xs="4">
                            <div
                                    class="custom-control custom-checkbox"
                                    style="position:relative;right: 5%;top:0%;display: inline">
                                <input type="checkbox" class="custom-control-input" id="unselect_all"
                                       name="unselect_all"
                                       v-model="unselect_all"
                                >
                                <label class="custom-control-label" id="unselect_all_label"
                                       for="unselect_all">{{ $t('selectpicker.nothing') }}</label>
                            </div>
                        </kt-col>
                    </kt-row>
                </kt-form-section>
            </div>
        </form>
        <div id="document_rejection_reasons" class="modal fade rtl" role="dialog">
            <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <div id="document_rejection_reasons_title">{{ $t('pos.document_rejection_reasons') }}</div>
                        <button type="button" class="close float-right mr-0" data-dismiss="modal">&times;</button>
                    </div>
                    <div id="data_sheet" class="modal-body mb-4">
                        <table class="table table-hover">
                            <thead id="rejection_reasons">
                            </thead>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <kt-col lg="2" md="2" xs="4">
            <kt-form-action style=" display: none;">
                <kt-button
                        data-toggle="modal" data-target="#document_rejection_reasons"
                        variant="success"
                        type="submit"
                        id="document_rejection_reasons_fire"
                >
                </kt-button>
            </kt-form-action>
        </kt-col>
    </div>
</template>

<script>
import $ from 'jquery';
import {i18n} from '@/plugins/i18n';
import {customerType} from '@/constants/posNovin';
import {documentFormat,documentStatuses} from '@/constants/PosDocuments';
import {posService} from '@/common/api.service';
import toastr from "toastr";
import {posStatuses, managerCanEditDocuments, visitorCanEditDocuments, manageDocuments} from '@/constants/PosStatus';


export default {
    data() {
        return {
            posStatuses,
            customerType,
            managerCanEditDocuments,
            visitorCanEditDocuments,
            manageDocuments,
            images_url: {},
            can_change_documents: false,
            show_delete_icon: false,
            p: 0,
            documentFormat,
            documentStatuses,
            checkboxes: {
                card_acceptance_contract: false,
                statute_pages_img: false,
                national_card_img: false,
                birth_certificate_card_img: false,
                passport_img: false,
                business_license_img: false,
                iban_certificate: false,
                change_iban_form: false,
                installation_form: false,
                deposit_receipt: false,
                phone_bill: false,
                national_card_of_second_sh: false,
                national_card_of_first_sh: false,
                renting_or_ownership_document: false,
                delegation_of_authority_form: false,
                last_newspaper_img_introduce_sh: false,
                delegation_of_authority_national_card: false,
                birth_certificate_first_page_of_first_sh: false,
                birth_certificate_first_page_of_second_sh: false,
                amayesh_card_img: false,
                certificate_form: false,
            },
            select_all: false,
            unselect_all: false,
            image_type_view: {
                card_acceptance_contract: null,
                statute_pages_img: null,
                national_card_img: null,
                birth_certificate_card_img: null,
                passport_img: null,
                business_license_img: null,
                iban_certificate: null,
                change_iban_form: null,
                installation_form: null,
                deposit_receipt: null,
                phone_bill: null,
                national_card_of_second_sh: null,
                national_card_of_first_sh: null,
                renting_or_ownership_document: null,
                delegation_of_authority_form: null,
                amayesh_card_img: null,
                last_newspaper_img_introduce_sh: null,
                delegation_of_authority_national_card: null,
                birth_certificate_first_page_of_first_sh: null,
                birth_certificate_first_page_of_second_sh: null,
                certificate_form: null,
            } ,
            document_classes: {
                card_acceptance_contract: '',
                statute_pages_img: '',
                national_card_img: '',
                birth_certificate_card_img: '',
                passport_img: '',
                business_license_img: '',
                iban_certificate: '',
                change_iban_form: '',
                installation_form: '',
                deposit_receipt: '',
                phone_bill: '',
                national_card_of_second_sh: '',
                national_card_of_first_sh: '',
                renting_or_ownership_document: '',
                delegation_of_authority_form: '',
                amayesh_card_img: '',
                last_newspaper_img_introduce_sh: '',
                delegation_of_authority_national_card: '',
                birth_certificate_first_page_of_first_sh: '',
                birth_certificate_first_page_of_second_sh: '',
                certificate_form: '',
            }
        }
    },
    props: {
        form_data: {
            type: Object
        },
        wizard: {
            type: Object
        },
    },
    watch: {
        checkboxes: {
            handler(newValue, oldValue) {
                this.form_data.document_checkboxes = newValue;
                let unselect = false;
                let select = true;
                for (let key in newValue) {
                    if (this.checkboxes[key] == true) {
                        unselect = true;
                    } else select = false;
                }
                if (unselect == true) {
                    this.unselect_all = false
                }
                if (select == false) {
                    this.select_all = false
                }
            },
            deep: true
        },
        select_all: {
            handler(newValue, oldValue) {
                if (newValue == true) {
                    this.unselect_all = false
                    this.selectOrUnselectAll(true)
                }
            },
        },
        unselect_all: {
            handler(newValue, oldValue) {
                if (newValue == true) {
                    this.select_all = false
                    this.selectOrUnselectAll(false)
                }
            },
        },
        wizard: {
            handler(newValue, oldValue) {
                this.canChangeDocuments();
                this.canDeleteDocuments();
            },
            deep: true
        },
    },
    methods: {
        processFile(e) {
            const name = e.target.name;
            let file = e.target.files[0];
            let size_validation = this.validateSize(event.target)
            let format_validation = this.validateFormat(event.target)
            if (size_validation != false && format_validation == true) {
                this.images_url[name] = URL.createObjectURL(file);
                this.form_data.documents[name] = file

                let jq_file = $(event.target);
                let file_name = jq_file.val();
                let extension = file_name.replace(/^.*\./, '');

                if (extension.toLowerCase() === 'pdf')
                    this.image_type_view[name] = this.documentFormat.PDF
                else
                    this.image_type_view[name] = this.documentFormat.IMAGE
            }
        },
        deleteFile(name) {
            if ((this.wizard.operation === 'edit' || this.wizard.document_operation == this.manageDocuments.UPLOAD)&& this.form_data.documents[name].id) {
                let params = {
                    pos_request_id: this.form_data.id,
                    file_id: this.form_data.documents[name].id,
                }
                var result = confirm(i18n.t('pos.message.remove_alert'));
                if (!result) return;

                posService.removeDocument(params).then(response => {
                    this.form_data.documents[name] = ''
                    this.images_url[name] = '';
                    return this.toastr.success(response.data.message)
                }).catch(({response}) => {
                    return this.toastr.error(response.data.message)
                })
            } else {
                this.form_data.documents[name] = ''
                this.images_url[name] = '';
            }
        },
        selectOrUnselectAll(check) {
            for (let key in this.checkboxes) {
                this.checkboxes[key] = check;
            }
        },
        setCheckboxFirstData() {
            for (let key in this.checkboxes) {
                this.checkboxes[key] = check;
            }
        },
        afterDispatch() {
            setTimeout(() => {
                $('.kt-selectpicker').selectpicker({
                    size: 6,
                    liveSearch: true,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_chose')
                });

            }, 500);
        },
        validateSize(file) {
            for (let i = 0; i < file.files.length; i++) {
                var FileSize = file.files[i].size / 1024 / 1024; // in MB
                if (FileSize > 5) {
                    return this.toastr.error(i18n.t('authenticate.hint.sixth'))
                }
            }
            return true
        },
        validateFormat(file) {
            let jq_file = $(file);
            let file_name = jq_file.val();
            let extension = file_name.replace(/^.*\./, '');
            if (extension === file_name) {
                extension = '';
            } else {
                extension = extension.toLowerCase();
            }
            switch (extension) {
                case 'jpg':
                case 'jpeg':
                case 'png':
                case 'pdf':
                    break;
                default:
                    return this.toastr.error(i18n.t('authenticate.input_format_err'))
            }
            return true
        },
        canChangeDocuments() {
            if (this.wizard.document_operation == manageDocuments.EDIT ||
                    this.wizard.document_operation == manageDocuments.UPLOAD) return this.can_change_documents = true;
        },
        canDeleteDocuments() {
            if ((this.$can('manage', 'pos') || this.wizard.operation === 'create' ||
                    this.form_data.status === posStatuses.CORRECTION || this.form_data.status === posStatuses.PENDING)) {
                return this.show_delete_icon = true
            }
        },
        setImagesUrl() {
            let images_url = this.form_data.images_url
            for (let key in images_url) {
                if (images_url[key]) {
                    if (images_url[key].includes('.pdf')) {
                        this.image_type_view[key] = this.documentFormat.PDF
                    } else
                        this.image_type_view[key] = this.documentFormat.IMAGE
                }
            }
            this.images_url = images_url
        },
        getDocumentStatusClass() {
            for (let key in this.form_data.documents) {
                let status = this.form_data.documents[key].status
                if (status == this.documentStatuses.PENDING)
                    this.document_classes[key] = 'badge badge-primary';
                else if (status == this.documentStatuses.UPLOADED)
                    this.document_classes[key] = 'badge badge-light';
                else if (status == this.documentStatuses.CHECK_BY_PSP)
                    this.document_classes[key] = 'badge badge-dark';
                else if (status == this.documentStatuses.CONFIRMED)
                    this.document_classes[key] = 'badge badge-success';
                else if (status == this.documentStatuses.REJECTED)
                    this.document_classes[key] = 'badge badge-danger';
                else if (status == this.documentStatuses.UNCOMPLETED)
                    this.document_classes[key] = 'badge badge-warning';
            }
        },
        show_rejection_reasons(document_name){
            let rejection_reasons = $('#rejection_reasons').empty()
            let status = this.form_data.documents[document_name].status
            let reasons = this.form_data.documents[document_name].rejection_reasons.rejection_reason
            if (!reasons || status != this.documentStatuses.REJECTED) return;
            for (let i = 0;i<reasons.length ; i++){
                rejection_reasons.append(
                        '<tr>' +
                        '<td style="width: 155px;">' + reasons[i].ErrorMessage + '</td>' +
                        '</tr>'
                )
            }
            document.getElementById("document_rejection_reasons_fire").click();
        }
    },
    mounted() {
        this.afterDispatch()
        this.setImagesUrl()
        this.form_data.document_checkboxes = this.checkboxes;
        this.getDocumentStatusClass()

    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
    }
}
</script>
<style>
.kt-form-label {
    text-align: right !important;
}

.special-tooltip {
    position: relative;
    display: inline-block;
}

.special-tooltip .tooltip-text {
    visibility: hidden;
    background-color: #555;
    color: #fff;
    text-align: center;
    padding: 5px 10px;
    border-radius: 6px;
    position: absolute;
    z-index: 1;
    bottom: 125%;
    opacity: 0;
    transition: opacity 0.3s;
    min-width: 60px !important;
}

.special-tooltip .tooltip-text::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    /*margin-left: -5px;*/
    border-width: 5px;
    border-style: solid;
    border-color: #555 transparent transparent transparent;
}

.special-tooltip:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
}

.modal .modal-content .modal-header .close:before {
    content: "" !important;
}

.modal .modal-content .modal-body .w-100 {
    max-height: 2000px !important;
}

.modal .modal-content .modal-header .close {
    font-size: 1.8rem;
    line-height: .7;
}

.w-100 {
    max-height: 200px !important;
}
</style>